import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation, EventEmitter, Output, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject } from 'rxjs';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { FuseUtils } from '@fuse/utils';
import { ScrumboardService } from '../../../scrumboard.service';
import { takeUntil } from 'rxjs/operators';
import { ParseService } from 'app/shared/common/parse/parse.service';
import axios from 'axios';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Lightbox } from 'ngx-lightbox';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { HttpClient } from '@angular/common/http';
import { SocketService } from 'app/shared/common/helper/socket.service';
import { Configuration } from 'app/app.configuration';
import { DataService } from 'app/shared/common/helper/http-service';

@Component({
    selector: 'scrumboard-board-card-dialog',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ScrumboardCardDialogComponent implements OnInit, OnDestroy {

    card: any;
    cardValue: any;
    board: any;
    boards: any;
    list: any;
    firstname: String;
    lastname: String;
    rowData = [];
    profileId = '';
    resourceRoleList = [];
    todoImportant: boolean = false;
    todoStarred: any;
    tags: any[];
    tagArray = [];
    members = [];
    assigneesId = [];
    labelList = [];
    toggleInArray: any;
    estimationHours: string;
    completionHours: string;
    currentUser: any;
    boardList = [];
    editCardComments: any;

    @Output()
    cardLabelsChanged: EventEmitter<any>;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    @ViewChild('checklistMenuTrigger', { static: false })
    checklistMenu: MatMenuTrigger;
    @ViewChild('newCheckListTitleField', { static: false })
    newCheckListTitleField;

    // Private
    private _unsubscribeAll: Subject<any>;
    assignedResources = [];
    profileid = [];
    projectId: any;
    attachments = [];
    activities = [];
    today = new Date();
    splitedValue = [];
    items = [];
    empRole: any;
    allowAccess: boolean = false;
    listOfTaskType: [];
    boardListName: any;
    activeStatus: any;
    storyPoints = [];
    boardRule = [];
    oldEstimatedHours = 0;
    newEstimatedHours = 0;
    oldCompletedHours = 0;
    newCompletedHours = 0;
    oldStoryPoints: any;
    activityBadge: any;
    commentsBadge: any;
    attachmentsBadge: any;
    data: any;
    todoDate: any;
    inprogressDate: any;
    completedDate: any;
    readyforQaDate: any;
    reopenDate: any;
    closedDate: any;
    currentUserProfile = '';

    /**
     * Constructor
     *
     * @param {MatDialogRef<ScrumboardCardDialogComponent>} matDialogRef
     * @param _data
     * @param {MatDialog} _matDialog
     * @param {ScrumboardService} _scrumboardService
     */
    constructor(
        public matDialogRef: MatDialogRef<ScrumboardCardDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _matDialog: MatDialog,
        private _scrumboardService: ScrumboardService,
        private parseService: ParseService,
        private storageConfiguration: StorageConfiguration,
        private toastr: ToastrService,
        private _lightbox: Lightbox,
        private hardCodedValues: HardCodedValues,
        private spinner: NgxSpinnerService,
        public dialog: MatDialog,
        private activityCenterService: ActivityCenterService,
        private http: HttpClient,
        private _socket: SocketService,
        private dataService: DataService,
        private configuration: Configuration
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.currentUser = this.parseService.instance.User.current();
        this.firstname = this.parseService.instance.User.current().get('firstName');
        this.lastname = this.parseService.instance.User.current().get('lastName');
        this.cardLabelsChanged = new EventEmitter();
        this.toggleInArray = FuseUtils.toggleInArray;
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);

        this.tags = [
            { id: 1, title: 'Front End' },
            { id: 2, title: 'Back End' },
            { id: 3, title: 'Api' },
            { id: 4, title: 'Mobile' },
        ];
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit() {
        this.getBoardRule();
        this.profileId = this.parseService.instance.User.current().get('profile').id;

        let image = '';
        let currentUserProfileImage = this.parseService.instance.User.current().get('profile').get('profileImageInfo');
        if (this.isEmpty(currentUserProfileImage)) {
            image = this.hardCodedValues.defaultProfileImg;
        } else {
            image = currentUserProfileImage.url
        }
        this.currentUserProfile = image;

        if (this.empRole === 'Admin' || this.empRole === 'Leader') {
            this.allowAccess = true;
        }
        this.activeStatus = this._data.activeStatus;

        this._scrumboardService.onBoardChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(board => {
            this.board = board;

            this.card = this.board.cards.find((_card) => {
                return this._data.cardId === _card.id;
            });

            if (this.card.todoDateActivity.length > 0) {
                this.todoDate = new Date(this.card.todoDateActivity[0].date);
            }
            if (this.card.inProgressDateActivity.length > 0) {
                this.inprogressDate = new Date(this.card.inProgressDateActivity[0].date);
            }
            if (this.card.completedDateActivity.length > 0) {
                this.completedDate = new Date(this.card.completedDateActivity[0].date);
            }
            if (this.card.readyForQaDateActivity.length > 0) {
                this.readyforQaDate = new Date(this.card.readyForQaDateActivity[0].date);
            }
            if (this.card.reOpenDateActivity.length > 0) {
                this.reopenDate = new Date(this.card.reOpenDateActivity[0].date);
            }
            if (this.card.closedDateActivity.length > 0) {
                this.closedDate = new Date(this.card.closedDateActivity[0].date);
            }

            this.activityBadge = this.card.activities.length;
            this.commentsBadge = this.card.comments.length;
            let cardsComments = JSON.parse(JSON.stringify(this.card.comments));
            this.editCardComments = cardsComments.map(x => {
                x.editMode = false;
                return x;
            })
            this.attachmentsBadge = this.card.attachments.length;

            if (this.card != undefined) {
                this.card.startDate = new Date(this.card.startDate.iso != undefined ? this.card.startDate.iso : this.card.startDate);
            }

            if (this.card != undefined) {
                this.boardListName = this.card.boardListName;
            }

            if (this.card != undefined) {
                this.activities = this.card.activities;
                this.cardValue = JSON.parse(JSON.stringify(this.card));
            }

            if (this.card != undefined) {
                this.oldEstimatedHours = JSON.parse(JSON.stringify(this.card.estimatedHours));

                this.oldStoryPoints = JSON.parse(JSON.stringify(this.card.storyPoints));

                this.estimationHours = this.secondsToHms(this.card.estimatedHours);
                this.splitedValue = this.estimationHours.split(':');
            }

            if (this.card != undefined) {
                this.oldCompletedHours = JSON.parse(JSON.stringify(this.card.completedHours));
                this.completionHours = this.secondsToHms(this.card.completedHours);
                this.splitedValue = this.completionHours.split(':');
            }

            this.list = this.board.lists.find((_list) => {
                return this._data.listId === _list.id;
            });
        });

        this._scrumboardService.onBoardChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(board => {
                this.boards = board;
                let project = this.boards.project;
                let projectId = project.id;
                this.projectId = project.id;
                this.getEmployees(projectId);
            });
        this.getBoardList();
    }

    /**
     *  Get Board Rule
     */
    getBoardRule() {
        let dataSettings = this.parseService.instance.Object.extend('DataSettings');
        let query = new this.parseService.instance.Query(dataSettings);
        query.find().then(results => {
            let result = results[0];
            this.boardRule = result.get('boardRule');
            this.listOfTaskType = result.get('typeOfTask');
            this.storyPoints = result.get('storyPoints');
            this.labelList = result.get('taskType');
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Remove due date
     */
    addDueDate(): void {
        if (this.card.due) {
            this.card.due = new Date(this.card.due);
        }
        this.updateCard();
    }

    addStartDate(): void {
        if (this.card.start) {
            this.card.start = new Date(this.card.start);
        }
        this.updateCard();
    }

    removeDueDate(): void {
        this.card.dueDate = '';
        this.updateCard();
    }

    /**
    * Card labels changed
    */
    onCardLabelsChanged(): void {

        this.cardLabelsChanged.next();
    }

    addAttachments(event) {
        let size = event.target.files[0].size;
        let fileSize = Math.round(size / 1024)
        const file = event.target.files[0];
        if (file.type != 'application/pdf' && file.type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            && file.type != 'application/msword' && file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            && file.type != 'application/vnd.ms-excel' && file.type != "image/jpeg" && file.type != "image/jpg" && file.type != "text/plain"
            && file.type != "image/png") {
            this.toastr.warning('Please upload Document, excel, image and Pdf files only');
        }

        else if (fileSize <= 500) {
            var formData = new FormData();
            if (event.target.files.length > 0) {
                this.spinner.show();
                const file = event.target.files[0];
                formData.append('files', file);
                var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
                axios.post('https://corev2.whatsdare.com/file-api/api/v1/media', formData, {
                    headers: {
                        // 'authorization': 'Bearer r:275fc76ef2168814a16b37a759eb538c',
                        "authorization": "Bearer " + session,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(aresf => {
                    var test = aresf;
                    let name = test.data.url.split('/');
                    this.card.attachments.push({
                        id: test.data._id,
                        url: test.data.url,
                        time: new Date(),
                        name: name[4],
                        type: test.data.type
                    });
                    let message = 'Added a attachment - ' + name[4];
                    let activity = this.setActivityModel(message);
                    this.card.activities.unshift(activity);
                    this._scrumboardService.updateTasks(this.card, this.assigneesId, event.value, '', this.card.attachments);
                    this.spinner.hide();
                }).catch(err => {
                    this.spinner.hide();
                    this.toastr.warning(err.response.data.message);
                });
            }
        }
        else if (fileSize > 500) {
            this.toastr.warning('Please upload the file less than 500kb');
        }
    }

    /**
     * Toggle subscribe
     */
    toggleSubscribe(): void {
        this.card.subscribed = !this.card.subscribed;

        this.updateCard();
    }

    /**
     * Toggle cover image
     *
     * @param attachmentId
     */
    toggleCoverImage(attachmentId, type): void {
        if (this.card.idAttachmentCover === attachmentId) {
            this.card.idAttachmentCover = '';
            this.updateCard();
        }
        else if (type == 'image/jpeg' || type == 'image/png' || type == 'image/jpg') {
            this.card.idAttachmentCover = attachmentId;
            this.updateCard();
        }
        else {
            this.toastr.warning('Only image can make card cover');
        }
    }

    /**
     * Remove attachment
     *
     * @param attachment
     */
    removeAttachment(attachment): void {
        if (attachment.id === this.card.idAttachmentCover) {
            this.card.idAttachmentCover = '';
        }
        this.card.attachments.splice(this.card.attachments.indexOf(attachment), 1);
        const message = 'Removed a attachment - ' + attachment.name;
        let activity = this.setActivityModel(message);
        this.card.activities.unshift(activity);
        this.updateCard();
    }

    /**
     * Remove checklist
     *
     * @param checklist
     */
    removeChecklist(checklist): void {
        this.card.taskCheckList.splice(this.card.taskCheckList.indexOf(checklist), 1);
        this.updateCard();
    }

    async open(index: number): Promise<void> {
        let image = [];
        // open lightbox
        await this.card.attachments.forEach((element, index) => {
            index = index + 1;
            // if (element.type == 'image/jpeg' || element.type == 'image/png' || element.type == 'image/jpg') {
            image.push({
                src: element.url,
                caption: 'image' + ' ' + index,
                thumb: ''
            });
            // }
        });
        let test = image;
        this._lightbox.open(test, index);
    }

    close(): void {
        // close lightbox programmatically
        this._lightbox.close();
    }

    /**
     * Update checked count
     *
     * @param list
     */
    updateCheckedCount(list): void {
        const checkItems = list.checkItems;
        let checkedItems = 0;
        let allCheckedItems = 0;
        let allCheckItems = 0;

        for (const checkItem of checkItems) {
            if (checkItem.checked) {
                checkedItems++;
            }
        }

        list.checkItemsChecked = checkedItems;
        for (const item of this.card.taskCheckList) {
            allCheckItems += item.checkItems.length;
            allCheckedItems += item.checkItemsChecked;
        }

        this.card.checkItems = allCheckItems;
        this.card.checkItemsChecked = allCheckedItems;
        this.updateCard();
    }

    /**
     * Remove checklist item
     *
     * @param checkItem
     * @param checklist
     */
    removeChecklistItem(checkItem, checklist): void {
        checklist.checkItems.splice(checklist.checkItems.indexOf(checkItem), 1);
        this.updateCheckedCount(checklist);
        this.updateCard();
    }

    /**
     * Add check item
     *
     * @param {NgForm} form
     * @param taskCheckList
     */
    addCheckItem(form: NgForm, checkList): void {
        const checkItemVal = form.value.checkItem;

        if (!checkItemVal || checkItemVal === '') {
            return;
        }

        const newCheckItem = {
            name: checkItemVal,
            checked: false
        };

        checkList.checkItems.push(newCheckItem);
        this.updateCheckedCount(checkList);
        form.setValue({ checkItem: '' });
        this.updateCard();

    }

    /**
     * Add checklist
     *
     * @param {NgForm} form
     */
    addChecklist(form: NgForm): void {
        this.card.taskCheckList.push({
            id: FuseUtils.generateGUID(),
            name: form.value.checklistTitle,
            checkItemsChecked: 0,
            checkItems: []
        });

        form.setValue({ checklistTitle: '' });
        form.resetForm();
        this.checklistMenu.closeMenu();
        this.updateCard();

    }

    /**
     * On checklist menu open
     */
    onChecklistMenuOpen(): void {
        setTimeout(() => {
            this.newCheckListTitleField.nativeElement.focus();
        });
    }

    /**
     * Add new comment
     *
     * @param {NgForm} form
     */
    addNewComment(form: NgForm): void {
        const newCommentText = form.value.newComment;
        if (newCommentText != '' && newCommentText != undefined) {
            const createrProfile = this.currentUser.get('profile');
            const createrImg = createrProfile.get('profileImageInfo').url;
            const newComment = {
                name: this.firstname + ' ' + this.lastname,
                message: newCommentText,
                time: new Date(),
                createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
            };

            this.card.comments.unshift(newComment);
            form.setValue({ newComment: '' });
            this.updateCard();
        }
        else {
            this.toastr.warning('Please enter the comments')
        }
    }

    /**
     * Remove card
     */
    removeCard(): void {
        this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete the card?';

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.matDialogRef.close();
                this._scrumboardService.removeCard(this.card.id, this.list.id);
            }
        });
    }

    /**
     * Update card
     */
    updateCard(remove?): void {

        let activities = this.getActivity(this.cardValue, this.card);
        // this.activityCenterService.createActivity(activities, this.hardCodedValues.task, this.board.id);

        activities.forEach(element => {
            this.card.activities.unshift(element);
        });
        // this.card.activities = activities;
        this._scrumboardService.updateCard(this.card);
        this.getEmployees(this.projectId, remove);
    }


    getActivity(oldcard, newcard): any[] {
        let activities = [];
        // tslint:disable-next-line: forin
        for (const oldproperty in oldcard) {
            for (const newproperty in newcard) {
                if (oldproperty === newproperty) {
                    let activityModel = this.createActivity(oldproperty, oldcard[oldproperty], newcard[newproperty]);
                    if (activityModel.allow) {
                        activities.push(activityModel.activity);
                    }
                }
            }
        }
        return activities;
    }

    nextPage(event) {

        let activity = this.card.activities;
        let start = event.pageIndex * event.pageSize;
        this.activities = activity.slice(start, start + event.pageSize);
    }

    tabChange(index) {
        if (index == 1) {
            let activity = this.card.activities;
            this.activities = activity.slice(0, 10);
        }
    }

    createActivity(prop, oldValue, newValue) {

        let message = '';
        let activity = {};
        let allow = false;
        const type = this.typeCheck(prop === 'dueDate' || prop === 'startDate' ? newValue._d : newValue);
        const property = prop === 'taskRole' ? 'Role' : (prop === 'taskType' ? 'Priority' : prop.replace(/\b\w/g, l => l.toUpperCase()));
        switch (type) {
            case 'string':
                if (oldValue !== newValue) {
                    switch (prop) {
                        case 'idAttachmentCover':
                            message = this.coverImageActivity(newValue, message, oldValue);
                            break;
                        case 'boardListId':
                            let oldVal = this.boardList.filter(x => x.boardId === oldValue)[0];
                            let newVal = this.boardList.filter(x => x.boardId === newValue)[0];
                            if (oldVal != undefined) {
                                message = 'Card Changed from ' + oldVal.boardName + ' to ' + newVal.boardName;
                            }
                            break;
                        default:
                            message = oldValue === '' ? 'Added a ' + property + ' ' + newValue : 'Updated the ' + property + ' from ' + oldValue + ' to ' + newValue;
                            break;
                    }
                    allow = true;
                }
                break;
            case 'Date':
                if (prop != 'createdAt') {
                    const datePipe = new DatePipe('en-US');
                    const oldDate = datePipe.transform(oldValue.iso != undefined ? oldValue.iso : oldValue, 'MMM dd yyyy');
                    const newDate = datePipe.transform(newValue._d, 'MMM dd yyyy');
                    if (oldDate !== newDate) {
                        message = oldValue === '' ? 'Added a ' + property : 'Updated the ' + property + ' from ' + oldDate + ' to ' + newDate;
                        allow = true;
                    }
                    break;
                }
            case 'Array':
                if (prop !== 'taskType' && prop !== 'typeOfTask' && prop !== 'assigneesId' && prop != 'createdAt') {
                    if (oldValue.length !== newValue.length && prop !== 'activities' && prop !== 'attachments' && prop !== 'comments') {
                        if (oldValue.length === 0) {
                            let arrayValue = [];
                            if (prop !== 'taskCheckList') {
                                arrayValue = this.arrayDifference(oldValue, newValue);
                                message = 'Added a ' + property + ' - ' + arrayValue[1];
                            } else {
                                arrayValue = this.arrayObjectDiff(oldValue, newValue);
                                message = 'Added a ' + property + ' - ' + arrayValue[0].name;
                            }
                            allow = true;
                        } else {
                            let arrayValue = [];
                            if (prop !== 'taskCheckList') {
                                arrayValue = this.arrayDifference(oldValue, newValue);
                                const val1 = oldValue.includes(arrayValue.toString());
                                const val2 = newValue.includes(arrayValue.toString());
                                message = val1 === false && val2 === true ? 'Added a ' + property + ' - ' + arrayValue : 'Removed a ' + property + ' - ' + arrayValue;
                            } else {
                                arrayValue = this.arrayObjectDiff(oldValue, newValue);
                                const val1 = oldValue.includes(arrayValue[0]);
                                const val2 = newValue.includes(arrayValue[0]);
                                message = val1 === false && val2 === true ? 'Added a ' + property + ' - ' + arrayValue[0].name : 'Removed a ' + property + ' - ' + arrayValue[0].name;
                            }
                            allow = true;
                        }
                    }
                } else {
                    if (oldValue.length !== oldValue.length) {
                        if (oldValue.length === 0) {
                            let arrayValue = [];
                            message = 'Added a ' + property + ' - ' + newValue[0];
                            allow = true;
                        } else {
                            let arrayValue = [];
                            arrayValue = this.arrayDifference(oldValue, newValue);
                            const val1 = oldValue.includes(arrayValue.toString());
                            const val2 = newValue.includes(arrayValue.toString());
                            message = val1 === false && val2 === true ? 'Added a ' + property + ' - ' + arrayValue : 'Changed a ' + property + ' - ' + arrayValue[0] + ' to ' + arrayValue[1];
                            allow = true;
                        }
                    }

                }
                break;
            case 'Number':
                if (prop == 'estimatedHours') {
                    if (oldValue !== newValue) {
                        let oldVal = this.secondsToHms(oldValue);
                        let newVal = this.secondsToHms(newValue);
                        message = oldVal == '00:00' ? 'Added Estimated Hours ' + newVal : 'Estimated Hours Changed from ' + oldVal + ' to ' + newVal;
                        allow = true;
                    }
                }
                if (prop == 'completedHours') {
                    if (oldValue !== newValue) {
                        let oldVal = this.secondsToHms(oldValue);
                        let newVal = this.secondsToHms(newValue);
                        message = oldVal == '00:00' ? 'Added Completed Hours ' + newVal : 'Completed Hours Changed from ' + oldVal + ' to ' + newVal;
                        allow = true;
                    }
                }
                break;
        }
        activity = this.setActivityModel(message);
        return { activity: activity, allow };
    }


    private coverImageActivity(newValue: any, message: string, oldValue: any): any {
        if (newValue !== '') {
            const attachment = this.card.attachments.filter(x => x.id === newValue)[0];
            message = 'Added Cover Image as - ' + attachment.name;
        }
        else {
            const attachment = this.card.attachments.filter(x => x.id === oldValue)[0];
            message = 'Removed Cover Image';
        }
        return message;
    }

    arrayDifference(array1, array2) {
        let array = [];
        array1 = array1.toString().split(',');
        array2 = array2.toString().split(',');
        // for array1
        for (let i in array1) {
            if (array2.indexOf(array1[i]) === -1) {
                array.push(array1[i]);
            }
        }
        // for array2
        for (let i in array2) {
            if (array1.indexOf(array2[i]) === -1) {
                array.push(array2[i]);
            }
        }
        return array.sort((x, y) => x - y);
    }

    arrayObjectDiff(array1, array2): any {
        let array = [];
        array1.forEach((element, index) => {
            if (array2.findIndex(x => x.id === element.id) === -1) {
                array.push(element);
            }
        });
        array2.forEach((element, index) => {
            if (array1.findIndex(x => x.id === element.id) === -1) {
                array.push(element);
            }
        });
        return array;
    }

    typeCheck(Source): string {
        if (Source != null) {
            if (Source.constructor === Array) {
                return 'Array';
            } else if (Source.constructor === Object) {
                return 'object';
            } else if (Source.constructor === String) {
                return 'string';
            } else if (Source.constructor === Date) {
                return 'Date';
            } else if (Source.constructor === Number) {
                return 'Number';
            }
        }
    }

    async getEmployees(projectId, remove?) {
        this.assignedResources = [];
        let array = [];
        let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
        let query = new this.parseService.instance.Query(queryInstance);
        query.include('project');
        query.include('user');
        query.equalTo('project', {
            __type: 'Pointer',
            className: 'Project',
            objectId: projectId
        });
        query.equalTo('status', 'Assigned');
        query.find().then(results => {
            results.forEach(element => {
                let user = element.get('user');
                let profile = user.get('profile');
                let profileImage = profile.get('profileImageInfo') !== undefined ? profile.get('profileImageInfo').url : profile.get('profileImageInfo');
                let profileid = profile.id;
                let resourceName = element.get('username');
                let role = element.get('role');
                if (this.card != undefined) {
                    this.card.taskRole.forEach(element => {
                        if (role === element) {
                            array.push({
                                id: profileid,
                                resourceName: resourceName,
                                image: profileImage
                            });
                        }
                    });
                }
                this.assignedResources = array.filter((x, i, a) => a.indexOf(x) == i);
                this.profileid.push(profileid);
            });

            if (remove) {
                this.removeAssigneeNotInMemberList();
            }
        });
    }
    /**
     * * Remove the assignee they not in the list
     */
    async removeAssigneeNotInMemberList(): Promise<void> {
        const notInList = [];
        this.card.assignee.forEach(assigned => {
            const id = this.assignedResources.find(a => a.id === assigned.id);
            if (!id) {
                notInList.push(assigned.id);
            }
        });
        notInList.forEach(async id => {
            const removeIdIndex = this.card.assigneesId.indexOf(id);
            this.card.assigneesId.splice(removeIdIndex, 1);
            await this._scrumboardService.removeCardTaskRelation(id, this.card.id);
        });
        this.updateCard();
    }

    async assigningResource(member, type) {
        if (type.checked) {
            let message = 'Assigned - ' + member.resourceName;
            const activity = this.setActivityModel(message);
            this.card.activities.unshift(activity);
            await this._scrumboardService.addCardTaskRelation(member.id, this.card.id);
            this.updateCard();

            var queryProfile = new this.parseService.instance.Object('Profile');
            queryProfile.id = member.id;

            let datePipe = new DatePipe('en-US');
            let data = {
                title: this.card.title,
                description: this.card.description,
                cardNo: this.card.cardNumber,
                taskType: this.card.typeOfTask.join(),
                priority: this.card.taskType.join(),
                assigneEmailId: queryProfile.get('officialInfo').officialEmail,
                assigneName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
                profileImage: queryProfile.get('profileImageInfo').url,
                estimatedHours: this.secondsToHms(this.card.estimatedHours),
                projectName: this.board.project.get('projectInfo').projectName,
                boardId: this.board.id,
                dueDate: datePipe.transform(this.card.dueDate, 'dd/MM/yyyy'),
                cardNumber: this.card.cardNumber,
                sprintName: this.board.name,
                createdDate: this.card.createdAt
            };

            let sendSocket = {
                event_type: 'NEW_TASK_ASSIGNED',
                event_owner: {
                    id: this.parseService.instance.User.current().get('profile').id,
                    name: this.firstname + ' ' + this.lastname,
                },
                event_receiver: {
                    id: member.id,
                    name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
                },
                message: 'You have been assigned to a task ' + this.card.cardNumber + ' in ' + this.board.project.get('projectInfo').projectName + '(' + this.board.name + ')',
                event_created_Date: new Date(),
                initiated_source: 'web',
                task: {
                    title: this.card.title,
                    assigneName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
                    profileImage: queryProfile.get('profileImageInfo').url,
                    projectName: this.board.project.get('projectInfo').projectName,
                    cardNumber: this.card.cardNumber,
                    sprintName: this.board.name,
                }
            }
            if (this.profileId != member.id) {
                this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
            }

            this.dataService.add(this.configuration.scrumboardTaskAdd, data).subscribe((data: any) => {
            });
        } else {
            const message = 'Removed - ' + member.resourceName;
            const activity = this.setActivityModel(message);
            this.card.activities.unshift(activity);
            await this._scrumboardService.removeCardTaskRelation(member.id, this.card.id);
            this.updateCard();

            var queryProfile = new this.parseService.instance.Object('Profile');
            queryProfile.id = member.id;
            // let data = {
            //     title: this.card.title,
            //     description: this.card.description,
            //     cardNo: this.card.cardNumber,
            //     taskType: this.card.typeOfTask.join(),
            //     priority: this.card.taskType.join(),
            //     estimatedHours: this.card.estimatedHours,
            //     removedUserEmailId: queryProfile.get('officialInfo').officialEmail,
            //     profileImage: queryProfile.get('profileImageInfo').url,
            //     projectName: this.board.project.get('projectInfo').projectName,
            //     boardId: this.board.id,
            //     createdDate: this.card.createdAt
            // };

            // this.dataService.add(this.configuration.scrumboardTaskRemove, data).subscribe((data: any) => {
            // });

            let sendSocket = {
                event_type: 'NEW_TASK_UNASSIGNED',
                event_owner: {
                    id: this.parseService.instance.User.current().get('profile').id,
                    name: this.firstname + ' ' + this.lastname,
                },
                event_receiver: {
                    id: member.id,
                    name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
                },
                message: 'You have been unassigned to a task ' + this.card.cardNumber + ' in ' + this.board.project.get('projectInfo').projectName + '(' + this.board.name + ')',
                event_created_Date: new Date(),
                initiated_source: 'web',
                details: {
                    itemId: '',
                    type: 'Task',
                    title: this.card.title,
                    assigneName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
                    profileImage: queryProfile.get('profileImageInfo').url,
                    projectName: this.board.project.get('projectInfo').projectName,
                    cardNumber: this.card.cardNumber,
                    sprintName: this.board.name,
                }
            }
            if (this.profileId != member.id) {
                this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
            }
        }
    }

    setActivityModel(message): any {
        const createrProfile = this.currentUser.get('profile');
        const createrImg = createrProfile.get('profileImageInfo').url;
        const createrName = createrProfile.get('username');
        const activity = {
            message: message,
            createdBy: createrName,
            createdId: createrProfile.id,
            createdDate: new Date().toUTCString(),
            createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
        };
        return activity;
    }

    priority(item, array) {
        this.card.priority = item;
        const message = 'Added Priority to ' + array;
        let activity = this.setActivityModel(message);
        this.card.activities.unshift(activity);
        this.updateCard();
        return;

        if (array.indexOf(item) === -1) {
            array.splice(array.indexOf(item), 1);
            array.push(item);
            const message = 'Added Priority to ' + array;
            let activity = this.setActivityModel(message);
            this.card.activities.unshift(activity);
            this.updateCard();
        }
        else {
            array.splice(array.indexOf(item), 1);
        }
    }


    typeOfTask(item, array) {
        this.card.taskType = [];
        this.card.typeOfTask = [];
        this.card.taskType.push(item);
        this.card.typeOfTask.push(item);


        const message = 'Added Task Type to ' + array;
        let activity = this.setActivityModel(message);
        this.card.activities.unshift(activity);
        return;

        if (array.indexOf(item) === -1) {
            array.splice(array.indexOf(item), 1);
            array.push(item);

            const message = 'Added Task Type to ' + array;
            let activity = this.setActivityModel(message);
            this.card.activities.unshift(activity);

            this.updateCard();
        }
        else {
            array.splice(array.indexOf(item), 1);
        }
    }

    toggleInArrays(member): void {
        let members = this.members;
        if (members.length > 0) {
            let val = members.findIndex(x => x.id == member.id);
            if (val > -1) {
                members.splice(val, 1);
            } else {
                members.push(member);
            }

        } else {
            members.push(member);
        }
        this.members = members;
        this.assigneesId = [];

        members.forEach(element => {
            this.assigneesId.push(element.id);

        });
        this._scrumboardService.updateTasks(this.card, this.assigneesId, '', '', '');
    }

    updateLabel(val): void {
        switch (val) {
            case 'im':
                this.todoImportant = !this.todoImportant;
                break;
            default:
                this.todoStarred = !this.todoStarred;
                break;
        }

    }

    updateTitle(tag): void {
        let arrayVal = this.tagArray;
        if (arrayVal.length > 0) {
            let val = arrayVal.findIndex(x => x.id == tag.id);
            if (val > -1) {
                arrayVal.splice(val, 1);
            } else {
                arrayVal.push(tag.id);
            }

        } else {
            arrayVal.push(tag.id);
        }

        this.tagArray = arrayVal;
    }

    hasTag(id): boolean {
        let val = this.tagArray.filter(x => x == id);
        if (val.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }

    keyPress(event: any) {
        const pattern = /[0-9\+\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    async storyPointsUpdate() {
        await this.chartDataStoryPointsUpdate();
        this.updateCard();
    }

    async chartDataStoryPointsUpdate() {
        let sprintQuery = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(sprintQuery);
        query.equalTo('objectId', this.board.id);
        await query.find().then(results => {
            let result = results[0];
            let chartData = result.get('chartData');
            let cardType = this.card.cardType;
            switch (cardType) {
                case 'Planned':
                    chartData.storyPoints.planned.total = chartData.storyPoints.planned.total - Number(this.oldStoryPoints);
                    chartData.storyPoints.planned.total = chartData.storyPoints.planned.total + Number(this.card.storyPoints);
                    chartData.storyPoints.planned.remaining = chartData.storyPoints.planned.remaining - Number(this.oldStoryPoints);
                    chartData.storyPoints.planned.remaining = chartData.storyPoints.planned.remaining + Number(this.card.storyPoints);
                    break;
                case 'UnPlanned':
                    chartData.storyPoints.unPlanned.total = chartData.storyPoints.unPlanned.total - Number(this.oldStoryPoints);
                    chartData.storyPoints.unPlanned.total = chartData.storyPoints.unPlanned.total + Number(this.card.storyPoints);
                    chartData.storyPoints.unPlanned.remaining = chartData.storyPoints.unPlanned.remaining - Number(this.oldStoryPoints);
                    chartData.storyPoints.unPlanned.remaining = chartData.storyPoints.unPlanned.remaining + Number(this.card.storyPoints);
                    break;
                case 'Previous Sprint':
                    chartData.storyPoints.previousSprint.total = chartData.storyPoints.previousSprint.total - Number(this.oldStoryPoints);
                    chartData.storyPoints.previousSprint.total = chartData.hours.previousSprint.total + Number(this.card.storyPoints);
                    chartData.storyPoints.previousSprint.remaining = chartData.storyPoints.previousSprint.remaining - Number(this.oldStoryPoints);
                    chartData.storyPoints.previousSprint.remaining = chartData.hours.previousSprint.remaining + Number(this.card.storyPoints);
                    break;

                default:
                    break;
            }
            result.set('chartData', chartData);
            result.save();
        })
    }

    secondsToHms(d): string {
        d = Number(d);
        let h = Math.floor(d / 3600);
        let m = Math.floor((d % 3600) / 60);
        let s = Math.floor((d % 3600) % 60);

        let hDisplay = (h <= 9 ? '0' : '') + h;
        let mDisplay = (m <= 9 ? '0' : '') + m;
        // let sDisplay = (s <= 9 ? '0' : '') + s;
        // return hDisplay + ' ' + 'hours' + ' ' + mDisplay + ' ' + 'minutes';
        return hDisplay + ':' + mDisplay;
    }

    dateEstimate(event): void {

        // let estimatedHour = hours === undefined || '' ? hours = 0 : Number(hours);
        // let estimatedMinutes = minutes === undefined || '' ? minutes = 0 : minutes;
        // estimatedHour = estimatedHour * 3600;
        // estimatedMinutes = estimatedMinutes * 60;
        // let seconds = Math.abs(estimatedHour.valueOf() + estimatedMinutes.valueOf());
        // let estimatedtime = this.secondsToHms(seconds);
        // this.estimationHours = estimatedtime;
        // this.card.estimatedHours = seconds;
        // this.updateCard();

        // ngx- material-timepicker
        let dateString = event.split(':');
        let hours = dateString[0] * 3600;
        let minutes = dateString[1] * 60;
        let seconds = Math.abs(hours.valueOf() + minutes.valueOf());
        if (this.board.name != 'Backlogs') {
            this.chartDataUpdateEstimate()
        }
        let estimatedtime = this.secondsToHms(seconds);
        this.estimationHours = estimatedtime;
        this.newEstimatedHours = seconds;
        this.card.estimatedHours = seconds;
        this.updateCard();

        // owl picker
        // let estimatedHours = event.value.getHours() * 3600;
        // let estimatedMinutes = event.value.getMinutes() * 60;
        // let seconds = Math.abs(estimatedHours.valueOf() + estimatedMinutes.valueOf());
        // let estimatedtime = this.secondsToHms(seconds);
        // this.estimationHours = estimatedtime;
        // this.card.estimatedHours = seconds;
        // this.updateCard();
    }

    chartDataUpdateEstimate() {
        let sprintQuery = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(sprintQuery);
        query.equalTo('objectId', this.board.id);
        query.find().then(results => {
            let result = results[0];
            let chartData = result.get('chartData');
            let cardType = this.card.cardType;
            switch (cardType) {
                case 'Planned':
                    chartData.hours.planned.total = chartData.hours.planned.total - this.oldEstimatedHours;
                    chartData.hours.planned.total = chartData.hours.planned.total + this.newEstimatedHours;
                    break;
                case 'UnPlanned':
                    chartData.hours.unPlanned.total = chartData.hours.unPlanned.total - this.oldEstimatedHours;
                    chartData.hours.unPlanned.total = chartData.hours.unPlanned.total + this.newEstimatedHours;
                    break;
                case 'Previous Sprint':
                    chartData.hours.previousSprint.total = chartData.hours.previousSprint.total - this.oldEstimatedHours;
                    chartData.hours.previousSprint.total = chartData.hours.previousSprint.total + this.newEstimatedHours;
                    break;

                default:
                    break;
            }
            result.set('chartData', chartData);
            result.save();
        })
    }

    completedEstimate(event): void {
        let dateString = event.split(':');
        let hours = dateString[0] * 3600;
        let minutes = dateString[1] * 60;
        let seconds = Math.abs(hours.valueOf() + minutes.valueOf());
        this.newCompletedHours = seconds;
        if (this.board.name != 'Backlogs') {
            this.chartDataUpdateCompleted();
        }
        let completedTime = this.secondsToHms(seconds);
        this.completionHours = completedTime;
        this.card.completedHours = seconds;
        this.updateCard();

    }

    chartDataUpdateCompleted() {
        let sprintQuery = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(sprintQuery);
        query.equalTo('objectId', this.board.id);
        query.find().then(results => {
            let result = results[0];
            let chartData = result.get('chartData');
            let cardType = this.card.cardType;
            switch (cardType) {
                case 'Planned':
                    chartData.hours.planned.completed = chartData.hours.planned.completed - this.oldCompletedHours;
                    chartData.hours.planned.completed = chartData.hours.planned.completed + this.newCompletedHours;
                    break;
                case 'UnPlanned':
                    chartData.hours.unPlanned.completed = chartData.hours.unPlanned.completed - this.oldCompletedHours;
                    chartData.hours.unPlanned.completed = chartData.hours.unPlanned.completed + this.newCompletedHours;
                    break;
                case 'Previous Sprint':
                    chartData.hours.previousSprint.completed = chartData.hours.previousSprint.completed - this.oldCompletedHours;
                    chartData.hours.previousSprint.completed = chartData.hours.previousSprint.completed + this.newCompletedHours;
                    break;

                default:
                    break;
            }
            result.set('chartData', chartData);
            result.save();
        })
    }


    filterApply(from, to) {

        let fromDate = new Date(from);
        let toDate = to !== '' ? new Date(new Date(to).setHours(23, 59, 59)) : new Date(new Date().setHours(23, 59, 59));
        if (from == '') {
            this.activities = this.card.activities;
        } else {
            let filteredActivities = this.card.activities.filter(x => new Date(x.createdDate) >= new Date(fromDate) && new Date(x.createdDate) <= new Date(toDate));
            this.activities = filteredActivities;
        }
    }

    getMinDate(date) {
        return new Date(date);
    }

    clearFilter() {
        this.activities = this.card.activities;
    }

    async getRelations(result) {
        var relationResult = [];
        await result.query().each(function (obj) {
            relationResult.push(obj);
        });
        return relationResult;
    }

    async getBoardList() {
        let scrumboardList = [];
        let relationResult = [];
        let results = []
        let boardList = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(boardList);
        query.equalTo('objectId', this.board.id);
        await query.find().then(async result => {
            await this.getRelations(result[0].get('BoardLists')).then(result => {
                relationResult = result;
            });
            relationResult.forEach(element => {
                let index = results.indexOf({ boardId: element.id, boardName: element.get('name') });
                if (index == -1) {
                    results.push({ boardId: element.id, boardName: element.get('name') });
                }
            });
        });
        let status;
        let sortOrder = ['To Do', 'In-Progress', 'Completed', 'Ready for QA', 'Re-Open', 'Closed'];
        status = results.sort(function (a, b) {
            return sortOrder.indexOf(a.boardName) - sortOrder.indexOf(b.boardName);
        });

        this.boardList = status;

        if (this.card != undefined && this.card.boardListId != undefined && this.list != undefined) {
            this.card.boardListId = this.list.id;
            // let selectedBoardList = this.boardList.filter(list => list.boardId == this.card.boardListId);
            // let definedListRule = this.boardRule.filter(x => x.from == selectedBoardList[0].boardName);
            // let acceptedLists = definedListRule[0].to;
            // let filteredLists = this.boardList.filter(listDetail => acceptedLists.includes(listDetail.boardName))
            // this.boardList = filteredLists;
        }

    }

    uniqBy(a, key) {
        var index = [];
        return a.filter(function (item) {
            var k = key(item);
            return index.indexOf(k) >= 0 ? false : index.push(k);
        });
    }

    async changeList(list) {

        await this._scrumboardService.scrumboardListChange(this.card.id, this.list.id, list.value).then(res => {

            this.board.lists.forEach(_lists => {
                if (_lists.id == this.list.id) {
                    let removeCard = _lists.idCards.indexOf(this.card.id);
                    removeCard
                    if (removeCard > -1) { // checks if value exists
                        _lists.idCards.splice(removeCard, 1);
                    }
                }
            });
            this.board.lists.forEach(_lists => {
                if (_lists.id == list.value) {
                    let newCard = _lists.idCards.indexOf(this.card.id);
                    if (newCard == -1) {
                        _lists.idCards.push(this.card.id);
                    }
                }
            });
            this._data.listId = list.value;
            this._scrumboardService.updateBoardLists(this.board.lists);
            this.updateCard();

        });
    }

    editMessage(i, comment) {
        this.data = comment.message;
        this.editCardComments[i].editMode = true;

    }

    readOnlyChange(i, comment) {
        // this.data = 
        this.editCardComments[i].editMode = false;
        this.editCardComments[i].message = this.data;
        let editedCards = JSON.parse(JSON.stringify(this.editCardComments));
        editedCards.forEach(element => {
            delete element.editMode;
        });
        this.card.comments = editedCards;
        this.updateCard()
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

}
